const DISCOUNT_CODE = "FIRSTKIT10"; // TODO: Populate with liquid
const KLAVIYO_SESSION_KEY = "klaviyoFormCompleted";
const discountAdvertisement = document.querySelector(
  "#discount--advertisement"
);
const discountList = document.querySelector("#discount-list");

function createTag() {
  const discountTitle = document.querySelector("#discount-title");
  const discountAmount = document.querySelector("#discount-amount");
  const productPrice = document.querySelector("#afterpay-product-placement").innerText;
  
  if (
    !discountList ||
    !discountTitle ||
    !discountAmount ||
    !productPrice ||
    !discountAdvertisement
  ) {
    return;
  }

  const discountPercentage = parseInt(DISCOUNT_CODE.slice(-2)) / 100;

  const discount = parseInt(productPrice) * discountPercentage;

  const locale = afterpay_js_language + "-" + afterpay_js_country;
  
  const discountText = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: afterpay_js_currency,
  }).format(discount);

  discountTitle.innerText = DISCOUNT_CODE;
  discountAmount.innerText = discountText;
  discountAdvertisement.classList.add("hidden");
  discountList.querySelector("#discount--badge").classList.remove("hidden");
}

function addFormCompletionToSessionStorage() {
  if (!window.sessionStorage.getItem(KLAVIYO_SESSION_KEY)) {
    window.sessionStorage.setItem(KLAVIYO_SESSION_KEY, "true");
  }
}

window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == "open" || e.detail.type == "embedOpen") {
  }

  if (e.detail.type == "submit") {
    addFormCompletionToSessionStorage();
    createTag();
  }

  if (e.detail.type == "stepSubmit") {
  }

  if (e.detail.type == "redirectedToUrl") {
  }

  if (e.detail.type == "close") {
  }
});

// Are there any cart discounts applied and has the form has not been filled before?
if (
  discountList &&
  !discountList.querySelector(".discount--badge-cart") // &&
  // !window.sessionStorage.getItem(KLAVIYO_SESSION_KEY)
) {
  discountAdvertisement.classList.remove("hidden");
  discountAdvertisement.addEventListener("click", () => {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", KLAVIYO_FORM_ID]);
  });
}

// To prevent flashing of the discount badge list
if (
  discountList &&
  discountList.querySelectorAll("li:not(.hidden)").length > 0
) {
  discountList.classList.remove("hidden");
}


// Add event listener to announcement
document.querySelector('[data-show-popup="true"]')?.addEventListener("click", () => {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(["openForm", KLAVIYO_FORM_ID]);
});